export default "__VITE_ASSET__CXcdPPcv__"